import {
  Control,
  FieldValues,
  Path,
  useController,
  UseControllerProps,
} from "react-hook-form";

import { Prettify } from "viem";

import { getCurrencyErrorMessage } from "entities/currency";

import { Input, type InputProps } from "./input-currency";

type CustomProps<T extends FieldValues, N extends Path<T>> = {
  control: Control<T>;
  name: N;
  rules?: UseControllerProps<T, N>["rules"];
  onChange?: (value: string) => void;
};

export type Props<T extends FieldValues, N extends Path<T>> = Prettify<
  CustomProps<T, N> & Omit<InputProps, keyof CustomProps<T, N> | "value">
>;

export const RHFInput = <T extends FieldValues, N extends Path<T>>(
  props: Props<T, N>
) => {
  const { disabled, control, name, rules, errorMessage, onChange } = props;

  const { field, fieldState } = useController({
    disabled,
    control,
    name,
    rules,
  });

  const error = errorMessage ?? getCurrencyErrorMessage(fieldState.error);

  return (
    <Input
      {...props}
      {...field}
      errorMessage={error}
      onChange={(value) => {
        field.onChange(value);
        onChange?.(value);
      }}
    />
  );
};
